import * as _ from 'lodash'
import moment from 'moment'

import { CRUD, CrudModel } from '../../classes'
import { PatientUploadedFile } from '../patient'
import { ProductModel } from '../product'
import { REFERRAL_STATUS } from '../referral-status'
import { ReferralData } from './referral.data'

@CRUD({
  base: '/crud/referrals',
})
export class ReferralModel extends CrudModel {
  patientId: string
  appointmentIds: Set<string>
  insuranceId?: string
  carrierLookupId?: string
  carrierId?: string
  products: ProductModel[]
  productNames: string[]
  number: string
  startAt?: moment.Moment
  endAt?: moment.Moment
  note?: string
  status: REFERRAL_STATUS
  customFields?: Record<string, any>
  attachments?: PatientUploadedFile[]
  approvedAt?: moment.Moment
  approvedBy?: string

  constructor(data: ReferralData) {
    super(data, true)

    if (data.startAt) {
      this.startAt = this.transformDate(data.startAt, false)
    }
    if (data.endAt) {
      this.endAt = this.transformDate(data.endAt, false)
    }

    // this.products = (data.products || []).map((product: ProductData) => new ProductModel(product))
    // this.productNames = this.products.map((product: ProductModel) => product.name)
    this.appointmentIds = new Set(data.appointmentIds)
    if (data.approvedAt) {
      this.approvedAt = this.transformDate(data.approvedAt, false)
    }
    if (data.approvedBy) {
      this.approvedBy = data.approvedBy
    }
  }

  override toJSON(): any {
    return _.extend(super.toJSON(), {
      status: this.status,
      patientId: this.patientId,
      appointmentIds: this.appointmentIds ? [...this.appointmentIds] : undefined,
      insuranceId: this.insuranceId,
      carrierLookupId: this.carrierLookupId,
      carrierId: this.carrierId,
      products: this.products,
      number: this.number,
      startAt: this.startAt,
      endAt: this.endAt,
      customFields: this.customFields,
      note: this.note,
      approvedAt: this.approvedAt,
      approvedBy: this.approvedBy,
    })
  }
}
